/* Version: 3.5.137 */
'use client';
import styled from 'styled-components';
import { BREAKPOINTS } from '../spacing/index.js';
import { rem } from '../utils/functions.js';
import { typography } from './typography.js';

var StyledH1 = /*#__PURE__*/styled.h1.withConfig({
  displayName: "styledComponents__StyledH1",
  componentId: "sc-1tnhh3j-0"
})(["font-family:", ";font-weight:", ";font-size:", ";line-height:", ";color:", ";", " @media (max-width:", "px){font-size:", ";line-height:", ";}", ""], typography.fontFamily, typography.fontWeightLight, rem(44), rem(54), function (_ref) {
  var color = _ref.color;
  return color;
}, function (_ref2) {
  var disableFocusOutline = _ref2.disableFocusOutline;
  return disableFocusOutline && "&:focus {outline: none;}";
}, BREAKPOINTS.TABLET_PORTRAIT, rem(30), rem(40), function (_ref3) {
  var elementStyle = _ref3.elementStyle;
  return elementStyle;
});
var StyledH2 = /*#__PURE__*/styled.h2.withConfig({
  displayName: "styledComponents__StyledH2",
  componentId: "sc-1tnhh3j-1"
})(["font-family:", ";font-weight:", ";font-size:", ";line-height:", ";color:", ";", " @media (max-width:", "px){font-size:", ";line-height:", ";}", ""], typography.fontFamily, typography.fontWeightLight, rem(32), rem(42), function (_ref4) {
  var color = _ref4.color;
  return color;
}, function (_ref5) {
  var disableFocusOutline = _ref5.disableFocusOutline;
  return disableFocusOutline && "&:focus {outline: none;}";
}, BREAKPOINTS.TABLET_PORTRAIT, rem(26), rem(36), function (_ref6) {
  var elementStyle = _ref6.elementStyle;
  return elementStyle;
});
var StyledH3 = /*#__PURE__*/styled.h3.withConfig({
  displayName: "styledComponents__StyledH3",
  componentId: "sc-1tnhh3j-2"
})(["font-family:", ";font-weight:", ";font-size:", ";line-height:", ";color:", ";", " ", ""], typography.fontFamily, typography.fontWeightDemibold, rem(22), rem(32), function (_ref7) {
  var color = _ref7.color;
  return color;
}, function (_ref8) {
  var disableFocusOutline = _ref8.disableFocusOutline;
  return disableFocusOutline && "&:focus {outline: none;}";
}, function (_ref9) {
  var elementStyle = _ref9.elementStyle;
  return elementStyle;
});
var StyledH4 = /*#__PURE__*/styled.h4.withConfig({
  displayName: "styledComponents__StyledH4",
  componentId: "sc-1tnhh3j-3"
})(["font-family:", ";font-weight:", ";font-size:", ";line-height:", ";color:", ";", " ", ""], typography.fontFamily, typography.fontWeightDemibold, rem(18), rem(26), function (_ref10) {
  var color = _ref10.color;
  return color;
}, function (_ref11) {
  var disableFocusOutline = _ref11.disableFocusOutline;
  return disableFocusOutline && "&:focus {outline: none;}";
}, function (_ref12) {
  var elementStyle = _ref12.elementStyle;
  return elementStyle;
});
var StyledI = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__StyledI",
  componentId: "sc-1tnhh3j-4"
})(["font-family:", ";font-style:italic;", " ", ""], typography.fontFamilySerif, function (_ref13) {
  var disableFocusOutline = _ref13.disableFocusOutline;
  return disableFocusOutline && "&:focus {outline: none;}";
}, function (_ref14) {
  var elementStyle = _ref14.elementStyle;
  return elementStyle;
});
var StyledP = /*#__PURE__*/styled.p.withConfig({
  displayName: "styledComponents__StyledP",
  componentId: "sc-1tnhh3j-5"
})(["font-family:", ";color:", ";font-size:", ";font-weight:", ";line-height:", ";", " ", ""], typography.fontFamily, function (_ref15) {
  var color = _ref15.color;
  return color;
}, typography.fontSize, function (_ref16) {
  var weight = _ref16.weight;
  return weight;
}, typography.lineHeight, function (_ref17) {
  var disableFocusOutline = _ref17.disableFocusOutline;
  return disableFocusOutline && "&:focus {outline: none;}";
}, function (_ref18) {
  var elementStyle = _ref18.elementStyle;
  return elementStyle;
});
var StyledSmall = /*#__PURE__*/styled.small.withConfig({
  displayName: "styledComponents__StyledSmall",
  componentId: "sc-1tnhh3j-6"
})(["font-family:", ";color:", ";font-size:", ";line-height:", ";", " ", ""], typography.fontFamily, function (_ref19) {
  var color = _ref19.color;
  return color;
}, typography.fontSizeSmall, rem(20), function (_ref20) {
  var disableFocusOutline = _ref20.disableFocusOutline;
  return disableFocusOutline && "&:focus {outline: none;}";
}, function (_ref21) {
  var elementStyle = _ref21.elementStyle;
  return elementStyle;
});

export { StyledH1, StyledH2, StyledH3, StyledH4, StyledI, StyledP, StyledSmall };
